module.exports = __webpack_public_path__ + "static/media/afl_everyday_digital_with_guernsey.8f1eb86f.png";